import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  usersList: [],
  activeUser: {},
  fromDetailsPage: false,
  users: null,
  error: false,
  loading: false,
  added: false,
  edited: false
};

const initUsersStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true
  });
};

const editUserStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};


const editUserSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    edited: true
  });
};

const editUserFail = (state, action) => {
  return updateObject(state, {
    loading: false
  });
};
const addUserInit = (state, action) => {
  return updateObject(state, {
    added: false
  });
};

const addUserStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const addUserSuccess = (state, action) => {
  setUsers(state, action);

  return updateObject(state, {
    loading: false,
    added: true,

  });
};
const addUserFail = (state, action) => {
  return updateObject(state, {
    loading: false
  });
};
const getOneUserStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const getOneUserFail = (state, action) => {
  return updateObject(state, {
    loading: false
  });
};

const setUsers = (state, action) => {
  return updateObject(state, {
    loading: false,
    usersList: action.usersList,
    added: false,
    edited: false
  });
};
const setActiveUser = (state, action) => {
  return updateObject(state, {
    loading: false,
    activeUser: action.activeUser,
    added: false,
    edited: false,
    fromDetailsPage: false
  });
};
const setFromWifiHealthDetailsPage = (state, action) => {
  return updateObject(state, {
    fromDetailsPage: true
  });
};

const fetchUsersFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_USERS_START:
      return initUsersStart(state, action);
    case actionTypes.GET_ONE_USER_START:
      return getOneUserStart(state, action);
    case actionTypes.GET_ONE_USER_FAIL:
      return getOneUserFail(state, action);
    case actionTypes.EDIT_USERS_START:
      return editUserStart(state, action);
    case actionTypes.EDIT_USERS_SUCCESS:
      return editUserSuccess(state, action)
    case actionTypes.EDIT_USERS_FAIL:
      return editUserFail(state, action);
    case actionTypes.ADD_USERS_INIT:
      return addUserInit(state, action);
    case actionTypes.ADD_USERS_START:
      return addUserStart(state, action);
    case actionTypes.ADD_USERS_SUCCESS:
      return addUserSuccess(state, action)
    case actionTypes.ADD_USERS_FAIL:
      return addUserFail(state, action);
    case actionTypes.SET_USERS:
      return setUsers(state, action);
    case actionTypes.SET_ACTIVE_USER:
      return setActiveUser(state, action);
    case actionTypes.SET_FROM_USER_DETAILS_PAGE:
      return setFromWifiHealthDetailsPage(state, action);
    case actionTypes.FETCH_USERS_FAILED:
      return fetchUsersFailed(state, action);
    default:
      return state;
  }
};

export default reducer;
